export const ROUTE_INDEX = '/';
export const ROUTE_SWAP = '/';
export const ROUTE_MY_SWAP = '/my-swap';
export const ROUTE_GAME_START_ANIMATION = '/start';
export const ROUTE_GAME_EDITION_MENU = '/menu';
export const ROUTE_DAO = '/DAO';
export const ROUTE_DAO_PROPOSAL = '/DAO/:proposal_id';
export const ROUTE_STATS = '/stats';
export const ROUTE_WRAP = '/wrap';

// LIQUIDITY
export const ROUTE_LIQUIDITY_TOKENS = '/liquidity/tokens';
export const ROUTE_LIQUIDITY_POOLS = '/liquidity/pools';
export const ROUTE_LIQUIDITY_MY_LIQUIDITY = '/liquidity/my-liquidity';
export const ROUTE_LIQUIDITY_ADD_LIQUIDITY_SINGLE_SIDED = '/liquidity/add-liquidity-single-sided';
export const ROUTE_LIQUIDITY_ADD_LIQUIDITY_DOUBLE_SIDED = '/liquidity/add-liquidity-double-sided';
export const ROUTE_LIQUIDITY_REMOVE_LIQUIDITY = '/liquidity/remove-liquidity';
export const ROUTE_LIQUIDITY_REWARDS = '/liquidity/rewards';

// STAKE
export const ROUTE_STAKE = '/stake';
export const ROUTE_UNSTAKE = '/unstake';

//ANALYTICS
export const ROUTE_ANALYTICS = '/analytics';
export const ROUTE_ANALYTICS_KDX = '/analytics/kdx';
export const ROUTE_ANALYTICS_STATS = '/analytics/stats';
export const ROUTE_TOKEN_INFO = '/token-info/:token';

// BUY CRYPTO - SIMPLEX
export const ROUTE_BUY_CRYPTO = '/buy-crypto';
